<template>
  <!-- Provides the application the proper gutter -->
  <v-container fluid class="grey lighten-5">
    <v-snackbar v-model="snackbar" bottom :color="snackbarColor">
      {{ snackbarText }}
      <v-btn dark text @click="snackbar = false">x</v-btn>
    </v-snackbar>
    <v-card-title class="headline" primary-title>Números por llamar</v-card-title>
    <v-divider></v-divider>
    <v-row no-gutters class="mt-2">
      <v-col cols="2" id="colResumen">
        <v-list>
          <v-list-item-group color="indigo" v-model="selectedNumeradores" multiple>
            <template v-for="item in numerosRecepcionResumen.numeradores">
              <v-list-item
                :key="item.id"
                :value="item.id"
                :disabled="item.puedoLlamarDesdeMiPuesto == false"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" :true-value="item.id" color="indigo"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="display-1">
                      {{ item.letra }}
                      <v-icon color="green" v-if="item.conTurno !== 2">mdi-calendar-check</v-icon>
                      <v-icon color="red" v-if="item.conTurno !== 1">mdi-calendar-blank</v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-avatar class="headline">{{ item.cantidad }}</v-list-item-avatar>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">
                Con turno&nbsp;
                <v-icon color="green">mdi-calendar-check</v-icon>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar class="headline">{{ numerosRecepcionResumen.cantidadConTurno }}</v-list-item-avatar>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">
                Sin turno&nbsp;
                <v-icon color="red">mdi-calendar-blank</v-icon>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar class="headline">{{ numerosRecepcionResumen.cantidadSinTurno }}</v-list-item-avatar>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">Total</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar class="headline">{{ numerosRecepcionResumen.total }}</v-list-item-avatar>
          </v-list-item>
        </v-list>
        <v-btn
          block
          color="orange"
          class="my-5 white--text"
          @click="callNext()"
          :disabled="calling || !connected"
        >
          Llamar siguiente
          <v-icon right>mdi-bell-ring-outline</v-icon>
        </v-btn>
        <v-list dense class="mb-2">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1">
                Sala:
                <b>{{ salaActual.salaNombre }}</b>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1">
                Puesto:
                <b>{{ puestoActual.value }}</b>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-chip v-if="connected" class="ma-2" color="success" outlined>
          <v-icon left>mdi-ear-hearing</v-icon>
          {{ connectionState }}
        </v-chip>
        <v-chip v-else class="ma-2" color="error" outlined>
          <v-icon left>mdi-ear-hearing-off</v-icon>
          {{ connectionState }}
        </v-chip>
      </v-col>
      <v-col cols="10" style="padding-left: 20px;">
        <v-simple-table :height="window.height - 180" fixed-header style="background-color:inherit">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Número</th>
                <th class="text-left">Hora nro.</th>
                <th class="text-left">Observaciones</th>
                <th class="text-left">Hora turno</th>
                <th class="text-left">Servicio</th>
                <th class="text-left">Profesional</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody style="background:white">
              <tr v-for="(item, index) in numerosRecepcion" :key="item.id">
                <td
                  :class="{'display-1':!item.showPatient, 'title':item.showPatient}"
                >{{ item.numeroDisplay }}</td>
                <td>{{ item.horaNumero }}</td>
                <td>{{ item.observaciones }}</td>
                <td>{{ item.horaTurno }}</td>
                <td>{{ item.servicio }}</td>
                <td>{{ item.profesional }}</td>
                <td>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="calling || !connected"
                        icon
                        color="orange"
                        @click="callNro(item, index)"
                        v-on="on"
                      >
                        <v-icon>mdi-bell-ring-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Llamar a este número</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-card-actions class="mt-2">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="openLastCalls()">últimas llamadas</v-btn>
      <v-btn outlined color="primary" @click="goHome()">salir</v-btn>
    </v-card-actions>
    <v-dialog v-model="lastCallsDialog" width="1200">
      <app-last-calls :closeFn="closeLastCalls" :connected="isConnected"></app-last-calls>
    </v-dialog>
  </v-container>
</template>

<script>
import { LogLevel, HubConnectionBuilder } from '@microsoft/signalr'
import { mapActions, mapState } from 'vuex'
import LastCalls from './NumerosLlamados'
import getAPIUrl from '@/helpers/getAPIUrl'

export default {
  computed: {
    ...mapState('Numeros', ['numerosRecepcion', 'numerosRecepcionResumen']),
    ...mapState('InitConfig', ['salaActual', 'puestoActual']),
    connectionState: function () {
      if (this.connection !== null) {
        return this.connection.state
      }
      return ''
    },
    connected: function () {
      return this.isConnected()
    }
  },
  components: {
    appLastCalls: LastCalls
  },
  data () {
    return {
      connection: null,
      selectedNumeradores: [],
      apiUrl: '',
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      lastCallsDialog: false,
      window: {
        height: 0
      },
      calling: false
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    var vm = this
    vm.connection.stop()
    window.removeEventListener('resize', vm.handleResize)
  },
  watch: {
    selectedNumeradores: function (newValue, oldValue) {
      this.getNumerosRecepcion()
    }
  },
  mounted: async function () {
    // En Electron usar la URL del store, en web usar getAPIUrl
    let url
    if (typeof process !== 'undefined' && process.type === 'renderer') {
      url = this.getApiUrl
    } else {
      url = await getAPIUrl()
    }
    var vm = this
    vm.connection = new HubConnectionBuilder()
      .withUrl(`${url}/llamadasHub`)
      .configureLogging(LogLevel.Information) // Cambiar de Debug a Information para producción
      .withAutomaticReconnect([
        0, // reconexión inmediata
        2000, // 2 segundos
        5000, // 5 segundos
        10000, // 10 segundos
        30000, // 30 segundos
        60000 // 60 segundos - máximo, sin null para evitar loop infinito
      ])
      .build()

    vm.connection.start().then(function () {
      vm.joinSignalRGroup()
      vm.listenSignalREvents()
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error('Error al conectar SignalR:', err)
    })

    vm.connection.onreconnected(connectionId => {
      // eslint-disable-next-line no-console
      console.log('SignalR reconectado exitosamente:', connectionId)
      vm.joinSignalRGroup()
    })

    // Manejar fallas de reconexión
    vm.connection.onreconnecting(error => {
      // eslint-disable-next-line no-console
      console.warn('SignalR intentando reconectar...', error)
    })

    // Manejar cuando se agoten los intentos de reconexión
    vm.connection.onclose(error => {
      if (error) {
        // eslint-disable-next-line no-console
        console.error('SignalR desconectado con error:', error)
        vm.snackbarText = 'Conexión perdida. Refresque la página.'
        vm.snackbarColor = 'error'
        vm.snackbar = true
      } else {
        // eslint-disable-next-line no-console
        console.log('SignalR desconectado normalmente')
      }
    })

    vm.getNumerosRecepcionResumen().then(() => {
      vm.selectedNumeradores = vm.numerosRecepcionResumen.misNumeradoresIds
    })
  },
  methods: {
    ...mapActions('Numeros', [
      'fetchNumerosRecepcion',
      'fetchNumerosRecepcionResumen',
      'fetchNumerosRecepcionLlamados'
    ]),
    ...mapActions('Llamadas', ['llamarNumero', 'llamarSiguienteNumero']),
    handleResize () {
      this.window.height = window.innerHeight
    },
    getNumerosRecepcion () {
      var vm = this
      return vm.fetchNumerosRecepcion({
        salaId: vm.salaActual.salaId,
        numeradorIds: vm.selectedNumeradores ?? []
      })
    },
    getNumerosRecepcionResumen () {
      var vm = this
      return vm.fetchNumerosRecepcionResumen({
        salaId: vm.salaActual.salaId,
        puestoId: vm.puestoActual.id
      })
    },
    callNro (nro, index) {
      var vm = this
      var llamada = {
        quien: nro.numeroDisplay,
        puestoId: vm.puestoActual.id,
        numId: nro.id
      }
      vm.calling = true
      vm.llamarNumero(llamada)
        .then(() => {
          vm.numerosRecepcion.splice(index, 1)
          vm.snackbarText = `Llamando a ${llamada.quien}`
          vm.snackbar = true
          vm.snackbarColor = 'success'
          vm.calling = false
        })
        .catch(data => {
          vm.snackbarText = data.error[0]
          vm.snackbar = true
          vm.snackbarColor = 'error'
          vm.calling = false
        })
    },
    callNext () {
      var vm = this
      var params = {
        puestoId: vm.puestoActual.id,
        numeradorIds: vm.selectedNumeradores ?? []
      }
      vm.calling = true
      vm.llamarSiguienteNumero(params)
        .then(response => {
          vm.snackbarText = `Llamando a ${response.data.quien}`
          vm.snackbar = true
          vm.snackbarColor = 'success'
          vm.calling = false
        })
        .catch(data => {
          vm.snackbarText = data.error[0]
          vm.snackbar = true
          vm.snackbarColor = 'error'
          vm.calling = false
        })
    },
    joinSignalRGroup () {
      var vm = this
      vm.connection.invoke('AddToGroup', vm.salaActual.salaId.toString())
        .then(result => {
          // eslint-disable-next-line no-console
          console.log('Grupo unido con éxito, resultado:', result, 'salaId:', vm.salaActual.salaId.toString())
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error('Error al unirse al grupo:', err)
        })

      vm.connection.on('Joined', msg => {
        // eslint-disable-next-line no-console
        console.log('on Joined:', msg)
      })

      vm.connection.on('GroupJoinError', errMsg => {
        // eslint-disable-next-line no-console
        console.error('Error desde el servidor al unirse al grupo:', errMsg)
      })
    },

    listenSignalREvents () {
      var vm = this
      vm.connection.on('ReceiveNewLlamadaRecepcion', data => {
        vm.getNumerosRecepcionResumen().then(() => {
          vm.getNumerosRecepcion()
        })
      })
      vm.connection.on('ReceiveNewNumeroRecepcion', data => {
        vm.getNumerosRecepcionResumen().then(() => {
          vm.getNumerosRecepcion()
        })
      })
    },
    isConnected () {
      return this.connectionState.toLowerCase().trim() === 'connected'
    },
    goHome () {
      this.$router.push({ name: 'SetUp' })
    },
    openLastCalls () {
      var vm = this
      vm.fetchNumerosRecepcionLlamados({
        puestoId: vm.puestoActual.id
      })
      vm.lastCallsDialog = true
    },
    closeLastCalls () {
      this.lastCallsDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
